import styled from 'styled-components'

export const Container = styled.div`
  &[data-is-simple-mode='true'] {
    .hide-in-simple-mode {
      display: none;
    }
  }
`

export const OpenFiltersButton = styled.button`
  width: 100%;

  border-radius: 4px;
  border: none;

  background-color: rgb(${({ theme }) => theme.background.low});

  display: flex;
  gap: 8px;

  padding: 24px 0 18px 16px;

  .icon {
    flex-shrink: 0;

    color: rgb(${({ theme }) => theme.primary.base});
  }

  .texts {
    display: flex;
    flex-direction: column;
    gap: 6px;

    text-align: start;

    .filter {
      color: rgb(${({ theme }) => theme.primary.base});

      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
    }

    .status {
      color: rgb(${({ theme }) => theme.grayscale[200]});

      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
    }
  }

  @media only screen and (min-width: 800px) {
    display: none;
  }
`

export const FormContainer = styled.div`
  height: 100vh;

  padding: 20px 22px 100px 22px;

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  overflow-y: auto;

  background-color: rgb(${({ theme }) => theme.background.low});

  transform: translateY(100%);
  transition: transform 500ms ease;

  z-index: 10;

  ::-webkit-scrollbar-track {
    background-color: rgb(${({ theme }) => theme.background.low});
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(${({ theme }) => theme.grayscale.neutral}, 0.4);
  }

  &[data-visible='true'] {
    transform: translateX(0%);
  }

  @media only screen and (min-width: 800px) {
    position: static;
    height: auto;

    transform: none;

    padding: 24px 24px 16px 24px;

    border-radius: 8px;

    overflow-y: visible;
  }
`

export const ActionsButtons = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  gap: 10px;

  transform: translateY(100%);
  transition: transform 500ms ease;

  z-index: 10;

  box-shadow: 0px 4px 20px 0px #00000040;

  padding: 14px 21px;

  border-radius: 4px 4px 0 0;

  background-color: ${({ theme }) => (theme.isDark ? '#2C2C2C' : 'white')};

  &[data-visible='true'] {
    transform: translateX(0%);
  }

  .filter {
    width: 100%;

    border: none;

    color: rgb(${({ theme }) => theme.background.low});
    background-color: rgb(${({ theme }) => theme.primary.base});

    border-radius: 4px;
    padding: 8px 0;

    font-size: 16px;
    font-weight: 500;
    line-height: 22px;

    transition: opacity 300ms ease;

    :disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .back {
    width: 100%;

    border: none;

    color: rgb(${({ theme }) => theme.primary.base});
    background: none;

    border-radius: 4px;
    padding: 8px 0;

    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
  }

  @media only screen and (min-width: 800px) {
    display: none;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 30px;

  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;

    margin-bottom: 0;
  }

  .close {
    color: rgb(${({ theme }) => theme.primary.base});

    background: none;
    border: none;

    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
  }

  @media only screen and (min-width: 800px) {
    display: none;
  }
`

export const TextInput = styled.label`
  display: block;
  position: relative;

  margin-bottom: 20px;

  input {
    width: 100%;

    padding: 18px 20px;
    padding-left: 48px;

    font-size: 14px;
    font-weight: 500;
    line-height: 18px;

    color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#4A4A4A')};
    background: ${({ theme }) => (theme.isDark ? `rgb(${theme.grayscale[400]})` : 'white')};

    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => (theme.isDark ? '#595959' : '#CFCFCF')};

    ::placeholder {
      color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#4A4A4A')};
    }

    :focus {
      border-width: 1px;
      border-style: solid;
      border-color: ${({ theme }) => (theme.isDark ? '#595959' : '#CFCFCF')};
    }
  }

  .icon {
    position: absolute;
    left: 20px;
    top: 18px;
  }

  @media only screen and (min-width: 800px) {
    margin-bottom: 32px;
  }
`

export const SelectsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  margin-bottom: 32px;

  .double {
    display: flex;
    gap: 14px;
    justify-content: stretch;

    .input {
      width: 100%;
    }
  }

  .canceled-checkbox {
    display: none;
  }

  @media only screen and (min-width: 900px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px 32px;

    margin-bottom: 32px;

    .canceled-checkbox {
      display: flex;
      flex-wrap: wrap;
      gap: 4px 22px;

      .checkbox-group {
        display: flex;
        gap: 12px;
      }

      .title {
        color: ${({ theme }) => (theme.isDark ? '##FFFFFF' : '#868686')};

        font-size: 16px;
        font-weight: 700;
        line-height: 21px;

        margin: 0;

        display: block;
        width: 100%;
      }

      .checkbox {
        gap: 8px;

        color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#7C7C7C')};

        font-size: 14px;
        font-weight: 500;
        line-height: 23px;

        .indicator {
          border-radius: 4px;
          border-width: 1px;
          border-style: solid;
          border-color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#CFCFCF')};
          background-color: transparent;

          &[data-checked='true'] {
            border: 2px solid ${({ theme }) => `rgb(${theme.primary.base})`};
            background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
          }
        }
      }
    }
  }
`

export const CheckboxesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  margin-bottom: 45px;

  .group {
    .title {
      color: ${({ theme }) => (theme.isDark ? '##FFFFFF' : '#868686')};

      font-size: 16px;
      font-weight: 700;
      line-height: 21px;

      margin-bottom: 16px;
    }
    .wrapper {
      display: flex;
      flex-direction: column;
      gap: 32px;

      .checkbox-group {
        display: flex;
        gap: 16px;
        flex-direction: row;
      }

      .checkbox {
        gap: 12px;

        color: ${({ theme }) => (theme.isDark ? '#F9F9F9' : '#7C7C7C')};

        font-size: 14px;
        font-weight: 500;
        line-height: 23px;

        .indicator {
          border-radius: 4px;
          border-width: 1px;
          border-style: solid;
          border-color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#CFCFCF')};
          background-color: transparent;

          &[data-checked='true'] {
            border: 2px solid ${({ theme }) => `rgb(${theme.primary.base})`};
            background-color: ${({ theme }) => `rgb(${theme.primary.base})`};
          }
        }
      }
    }
  }

  @media only screen and (min-width: 800px) {
    flex-direction: row;
    justify-content: space-between;

    max-width: 1000px;

    margin-bottom: 32px;

    box-sizing: content-box;

    padding-right: 64px;
  }

  @media only screen and (min-width: 900px) {
    .hide-in-desktop {
      display: none;
    }
  }
`

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  width: fit-content;

  button {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;

    padding: 8px 16px;

    width: 100%;

    text-align: start;

    color: ${({ theme }) => (theme.isDark ? '#A7A7A7' : '#868686')};
    background: ${({ theme }) => (theme.isDark ? `rgb(${theme.grayscale[400]})` : 'white')};

    border-width: 0 1px 1px 1px;
    border-style: solid;
    border-color: ${({ theme }) => (theme.isDark ? '#595959' : '#CFCFCF')};

    transition: all 0.3s ease;

    &[data-active='true'] {
      color: #f9f9f9;
      background: rgb(${({ theme }) => theme.primary.base});
    }

    :first-child {
      border-radius: 4px 4px 0 0;
      border-top-width: 1px;
    }
    :last-child {
      border-radius: 0 0 4px 4px;
    }
  }

  @media only screen and (min-width: 900px) {
    flex-direction: row;

    button {
      border-width: 1px 1px 1px 0;

      width: unset;

      :first-child {
        border-radius: 4px 0 0 4px;
        border-left-width: 1px;
      }
      :last-child {
        border-radius: 0 4px 4px 0;
      }
    }
  }
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 36px;

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 36px;
    align-items: start;

    .first {
      .switch-mode {
        background: none;
        border: none;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;

        color: rgb(${({ theme }) => theme.primary.base});

        font-size: 18px;
        font-weight: 500;
        line-height: 18px;
      }
    }

    .last {
      .reset {
        background: none;
        border: none;

        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;

        color: rgb(${({ theme }) => theme.grayscale[200]});

        font-size: 18px;
        font-weight: 500;
        line-height: 23px;
      }

      .filter {
        display: none;

        width: 100%;

        border: none;

        color: rgb(${({ theme }) => theme.background.low});
        background-color: rgb(${({ theme }) => theme.primary.base});

        border-radius: 4px;
        padding: 8px 16px;

        font-size: 14px;
        font-weight: 500;
        line-height: 22px;

        transition: opacity 300ms ease;

        :disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }
    }
  }

  @media only screen and (min-width: 800px) {
    flex-direction: column-reverse;

    .buttons {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      width: 100%;

      .first {
        padding-left: 16px;

        .switch-mode {
          font-size: 14px;
        }
      }

      .last {
        display: flex;
        gap: 32px;
        align-items: center;

        .reset {
          font-size: 14px;
        }
        .filter {
          display: block;
        }
      }
    }
  }
`

export const SelectedFiltersContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 22px;

  .title {
    color: rgb(${({ theme }) => theme.grayscale[100]});

    font-size: 16px;
    font-weight: 600;
    line-height: 21px;

    margin-bottom: 0;

    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .empty-text {
      display: inline-block;
      font-weight: 500;
    }
  }

  .badges {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`

export const Badge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  padding: 6px 16px;

  font-size: 14px;
  font-weight: 500;
  line-height: 18px;

  background-color: rgb(${({ theme }) => theme.grayscale[400]});

  b {
    margin-right: 4px;
  }
  .icon {
    flex-shrink: 0;

    margin-left: 12px;

    color: rgb(${({ theme }) => theme.grayscale[100]});
  }

  .remove {
    display: flex;
    align-items: center;
    justify-content: center;

    background: none;
    border: none;
  }
`
